import {
  DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_BEGIN,
  DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_SUCCESS,
  DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_FAILURE,
  DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function airtableUpdateExternalDatabase(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_BEGIN,
    });
    const { projectId, version, externalDbUuid, fields, collectionId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/airtable/${externalDbUuid}`,
        { fields: fields, collectionId: collectionId },
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAirtableUpdateExternalDatabaseError() {
  return {
    type: DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_BEGIN:
      return {
        ...state,
        airtableUpdateExternalDatabasePending: true,
        airtableUpdateExternalDatabaseError: null,
      };

    case DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_SUCCESS:
      return {
        ...state,
        airtableUpdateExternalDatabasePending: false,
        airtableUpdateExternalDatabaseError: null,
      };

    case DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_FAILURE:
      return {
        ...state,
        airtableUpdateExternalDatabasePending: false,
        airtableUpdateExternalDatabaseError: action.data.error,
      };

    case DATA_CONNECTOR_AIRTABLE_UPDATE_EXTERNAL_DATABASE_DISMISS_ERROR:
      return {
        ...state,
        airtableUpdateExternalDatabaseError: null,
      };

    default:
      return state;
  }
}
